/**
 *
 * @author arman
 * @since 9/27/17
 *
 */
import React from 'react';

import utils from '../../utility/utils';
import appConstants from '../../utility/app-constants';
import BoxHeader from '../shared/box-header.component';

const styles = {
  root: {

  },
  innerDiv: {
    margin: '8px',
    height: '25px',
  },
  name: {
    fontWeight: 'bold',
    background: 'url(./images/icons/mission/view/doctor.png) no-repeat',
  },
  text: {
    color: '#000000',
    fontSize: '15px',
    marginTop: '5px',
    marginLeft: '40px',
    display: 'inline-block'
  },
  eta: {
    color: '#000000',
    fontSize: '15px',
    marginTop: '8px',
    marginLeft: '0px'
  }
};

/**
 *
 * @param {object} mission
 * @param {string} className
 * @param {object} style
 * @constructor
 */
const DoctorInfo = ({mission, className, style}) => {

  return (
    <div className={className} style={{...styles.root, ...style}}>
      <BoxHeader title='Doctor'/>
      <div style={{...styles.name, ...styles.innerDiv}}>
        <div style={styles.text}>{mission.doctor ? mission.doctor.user.name : 'Not Assigned yet'}</div>
      </div>
      {
        mission.status === appConstants.DISPATCHED  &&
        <div style={{...styles.eta, ...styles.innerDiv}}>
          <span>ETA: </span>
          <span>{mission.eta ? utils.toMomentCalendarDate(mission.eta) : 'N/A'}</span>
        </div>
      }
      {
        mission.feedback_time && mission.feedback_time >0 &&
        <div style={{...styles.eta, ...styles.innerDiv}}>
          <span>Rating on <span style={{fontWeight: 'bold'}}>time</span> devoted to patient: </span>
          <span>{mission.feedback_time}/5</span>
        </div>
      }
      {
        mission.feedback_attention && mission.feedback_attention > 0 &&
        <div style={{...styles.eta, ...styles.innerDiv}}>
          <span>Rating on <span style={{fontWeight: 'bold'}}>attention</span> devoted to patient: </span>
          <span>{mission.feedback_attention}/5</span>
        </div>
      }
      {
        mission.feedback_prescription_delivery && mission.feedback_prescription_delivery >0 &&
        <div style={{...styles.eta, ...styles.innerDiv}}>
          <span>Rating on <span style={{fontWeight: 'bold'}}>prescription</span> handover: </span>
          <span>{mission.feedback_prescription_delivery}/5</span>
        </div>
      }
      {
        mission.operator_rated_doctor!== 0 &&
        <div style={{...styles.eta, ...styles.innerDiv}}>
          <span>Operator Rated Doctor: </span>
          <span>{mission.operator_rated_doctor}/5</span>
        </div>
      }
    </div>
  )
};

export default DoctorInfo;


// WEBPACK FOOTER //
// ./src/screens/mission-view/doctor-info.component.js